module.exports = __webpack_public_path__ + "assets/wasm/basis_transcoder-47a150232d2d96f0c3e109417dfd06a3.wasm";